// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import scene from './metaData/scene'
export default {
  state: scene,
  actions
}
